import { View } from 'react-native'

import { styled } from '~/core/styled'

export const Container = styled(View, theme => {
  return {
    base: {
      minWidth: 320,
      minHeight: 64,
      flex: 1,
      backgroundColor: theme.colorFillNeutralDefault,
      borderTopLeftRadius: theme.borderRadiusMediumcontainer,
      borderTopRightRadius: theme.borderRadiusMediumcontainer,
      paddingHorizontal: theme.paddingInsetFourpulse,
      paddingVertical: theme.paddingInsetThreepulse,
      borderColor: theme.colorNone,
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
  }
})
